import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import banner1 from "../assets/banner1.jpg";
import banner2 from "../assets/banner2.jpg";
import banner3 from "../assets/banner3.jpg";
import banner4 from "../assets/banner4.jpg";
import { FaArrowRightLong } from "react-icons/fa6";

export default function HomeBanner1() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);
  const [activeSlide, setActiveSlide] = useState(0);

  const slides = [banner3, banner2, banner1, banner4];

  useEffect(() => {
    setReady(true);
  }, []);

  useEffect(() => {
    if (!ready) return;
    const interval = setInterval(() => {
      setActiveSlide((prev) => (prev + 1) % slides.length);
    }, 6000);
    return () => clearInterval(interval);
  }, [ready, slides.length]);

  if (!ready) {
    return (
      <div className="container d-flex justify-content-center align-items-center" style={{ minHeight: "80vh" }}>
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <section className="hero-section position-relative overflow-hidden p-0" aria-label="Home Hero">
      {/* ================= BACKGROUND LAYERS ================= */}
      {slides.map((banner, i) => (
        <div
          key={i}
          className={`hero-bg-layer ${i === activeSlide ? "active" : ""}`}
          style={{ backgroundImage: `url(${banner})` }}
        />
      ))}

      {/* ================= REFINED OVERLAY ================= */}
      <div className="hero-overlay-refined" />

      {/* ================= CONTENT ================= */}
      <div className="container hero-container">
        <div className="row">
          <div className="col-12">
            
            {/* Mission-based Eyebrow */}
            <div className="hero-eyebrow fade-in-up">
              NBAA Registered Firm - PF 407
            </div>

            {/* ATRIC Brand Headline */}
            <h1 className="hero-title fade-in-up delay-1 font-bold">
              ATRIC Consultants
            </h1>

            {/* Strategic Subheadline using Profile Data */}
            <p className="hero-subtitle fade-in-up delay-2">
              Premier Audit & Business Advisory Services
            </p>

            {/* Action Buttons */}
            <div className="d-flex flex-wrap gap-3 mt-4 fade-in-up delay-3">
              <button
                className="btn-professional-primary"
                onClick={() => appContext.navTo({ item: "services" })}
              >
                Our Services
                <FaArrowRightLong className="ms-2" />
              </button>

              <button
                className="btn-professional-outline"
                onClick={() => appContext.navTo({ item: "about_us" })}
              >
                Learn More
              </button>
            </div>
             
          </div>
        </div>
      </div>

      <style>{`
        .hero-section {
          height: calc(100vh - var(--topBarHeight)) !important;
          display: flex;
          align-items: center;
          background: #0f172a; 
        }

        .hero-bg-layer {
          position: absolute;
          inset: 0;
          background-size: cover;
          background-position: center;
          opacity: 0;
          transition: opacity 1.5s ease-in-out, transform 8s linear;
          transform: scale(1.1);
          z-index: 0;
        }

        .hero-bg-layer.active {
          opacity: 0.4; /* Slightly lowered for better text legibility */
          transform: scale(1);
          z-index: 1;
        }

        .hero-overlay-refined {
          position: absolute;
          inset: 0;
          background: linear-gradient(to right, rgba(15, 23, 42, 0.5) 0%, rgba(15, 23, 42, 0.25) 100%);
          z-index: 2;
        }

        .hero-container {
          position: relative;
          z-index: 3;
        }

        .hero-eyebrow {
          color: #38bdf8;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          font-size: 0.9rem;
          margin-bottom: 1rem;
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .hero-eyebrow::before {
          content: "";
          width: 40px;
          height: 2px;
          background: #38bdf8;
        }

        .hero-title {
          color: #ffffff;
          font-size: clamp(2.8rem, 7vw, 5rem);
          font-weight: 800;
          line-height: 1.1;
          margin-bottom: 1.5rem;
          text-transform: uppercase;
        }

        .text-accent {
          color: #1e3fae;
        }

        .hero-subtitle {
          color: #cbd5e1;
          font-size: 1.25rem;
          line-height: 1.6;
          max-width: 650px;
          margin-bottom: 2rem;
        }

        .btn-professional-primary {
          background: #1e3fae;
          color: white;
          padding: 16px 36px;
          border-radius: 4px;
          border: none;
          font-weight: 600;
          transition: all 0.3s ease;
          display: inline-flex;
          align-items: center;
        }

        .btn-professional-primary:hover {
          background: #474849;
          transform: translateY(-3px);
          box-shadow: 0 10px 20px rgba(0,0,0,0.2);
        }

        .btn-professional-outline {
          background: rgba(255, 255, 255, 0.05);
          color: white;
          padding: 16px 36px;
          border-radius: 4px;
          border: 1px solid rgba(255, 255, 255, 0.3);
          font-weight: 600;
          backdrop-filter: blur(8px);
          transition: all 0.3s ease;
        }

        .btn-professional-outline:hover {
          background: rgba(255, 255, 255, 0.15);
          border-color: white;
          transform: translateY(-3px);
        }

        .fade-in-up {
          animation: fadeInUp 0.8s ease forwards;
          opacity: 0;
        }

        .delay-1 { animation-delay: 0.2s; }
        .delay-2 { animation-delay: 0.4s; }
        .delay-3 { animation-delay: 0.6s; }

        @keyframes fadeInUp {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @media (max-width: 768px) {
          .hero-section { text-align: center; height: auto; padding: 100px 0; }
          .hero-eyebrow { justify-content: center; }
          .hero-eyebrow::before { display: none; }
          .btn-professional-primary, .btn-professional-outline { width: 100%; justify-content: center; }
        }
      `}</style>
    </section>
  );
}